module.exports = __webpack_public_path__ + "img/hungaria-bottle-stand.a0f58deb.png";